import cn from 'classnames'

import { ReactComponent as IconArrowRight } from 'assets/icons/IconArrowRight.svg'

const AssignedItemsButton = ({
  handleClick,
  customClass = '',
  label,
  assignedItems = 0,
  error = false,
  required = false,
  disabled = false,
  dataCy,
}) => {
  return (
    <button
      className={`assigned-items-button ${customClass}`}
      onClick={handleClick}
      type="button"
      data-cy={dataCy}
      disabled={disabled}
    >
      <div
        className={cn('assigned-items-button__label', {
          '-error': error,
          '-required': required,
        })}
      >
        {label}
      </div>
      <div className="assigned-items-button__assigned">
        {assignedItems} assigned
      </div>
      <IconArrowRight />
    </button>
  )
}

export default AssignedItemsButton
